/**
 * Encodes a UTF-8 string to a Base64 string.
 *
 * @param str The UTF-8 string to encode.
 * @returns The Base64 encoded string.
 */
export function utf8ToBase64(str: string): string {
  const encoder = new TextEncoder(); // Efficiently encodes the string as a UTF-8 byte sequence
  const bytes = encoder.encode(str); // Convert string to a byte array

  return btoa(String.fromCharCode(...bytes)); // Convert byte array to a Base64 string
}

/**
 * Decodes a Base64 string to a UTF-8 string.
 *
 * @param base64 The Base64 encoded string.
 * @returns The decoded UTF-8 string.
 */
export function base64ToUtf8(base64: string): string {
  const binary = atob(base64); // Decode the Base64 string to binary data
  const bytes = new Uint8Array(binary.length); // Create a typed array for the decoded binary data

  // Populate the byte array with the decoded binary data
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  const decoder = new TextDecoder(); // Decodes the byte array back to a UTF-8 string

  return decoder.decode(bytes);
}
